export default __webpack_public_path__ + "static/media/ionicons.bf69b013.woff";